import PokerTable from '@/components/PokerTable';

export default function PracticaPage() {
  return <PokerTable />;
}
